import { GlButton, GlLink, GlTooltipDirective, GlIcon } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import WikiMoreDropdown from './wiki_more_dropdown.vue?vue3';
import WikiSidebarToggle from './wiki_sidebar_toggle.vue?vue3';
export default {
    name: 'WikiStickyHeader',
    components: {
        GlButton,
        GlIcon,
        GlLink,
        WikiMoreDropdown,
        WikiSidebarToggle
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        isStickyHeaderShowing: {
            type: Boolean,
            required: true
        },
        pageHeading: {
            type: String,
            required: true
        },
        showEditButton: {
            type: Boolean,
            required: true
        },
        wikiPage: {
            type: Object,
            required: false,
            default: ()=>({})
        }
    },
    emits: [
        'edit',
        'toggle-subscribe'
    ],
    computed: {
        subscribeIcon () {
            return this.wikiPage?.subscribed ? 'notifications' : 'notifications-off';
        },
        subscribeTooltip () {
            return this.wikiPage?.subscribed ? __('Notifications are on') : __('Notifications are off');
        }
    }
};
